$( document ).ready(function() {
  $(".custom-collection .product-grid").slick({
   slidesToShow: 4,
   infinite:true,
   slidesToScroll: 1,
   prevArrow: false,
   nextArrow: false,
   autoplay: true,
   autoplaySpeed: 3000,
   responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

});

